<template>
    <modal height="auto" width="80%" :scrollable="true" name="client-medicament" classes="modal_default" :clickToClose="true"  @before-open="beforeOpen">
      <div class="card" data-testid="lab-results-prescription-dialog">
          <div class="card-header">
            Vypsání receptu pro {{ propClient.full_name }}
          </div>
          <div class="card-body">
            <client-medicament :prop-client-id="propClient.id"/>
          </div>
      </div>
    </modal>
</template>

<script>
  import ClientMedicament from '@/views/Client/components/ClientMedicament'

  export default {
    data () {
      return {
        reloadMedicament: false,
        reloadPrescription: false,
        medicamentToCopy: false
        //
      }
    },
    props: ['opened', 'doctorId', 'propClient'],
    methods: {
      beforeOpen () {
        console.log('oteviram modalko')
      }
    },
    watch: {
    },
    computed: {
    },
    components: {
      ClientMedicament
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Modal/ClientMedicament.vue?3ad19f58